import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";

export default function LeadSearch() {


    return (
        <div style={{display: 'flex', justifyContent: 'center', paddingTop: '50px'}}>
            <Grid container>
                <Grid item xs>
                    <h1>Hello !</h1>
                </Grid>
                <Grid item>
                </Grid>
            </Grid>
        </div>
    );
}
